import { MessageData } from "@store"

export function easingScrollTo(
  element: HTMLElement,
  Y: number,
  duration: number,
  easingFunction: (x: number) => number
) {
  return new Promise<void>((resolve) => {
    var start = Date.now(),
      from = element.scrollTop

    function scroll() {
      var currentTime = Date.now(),
        time = Math.min(1, (currentTime - start) / duration),
        easedT = easingFunction(time)

      element.scrollTop = easedT * (Y - from) + from

      if (time < 1) requestAnimationFrame(scroll)
      else resolve()
    }

    requestAnimationFrame(scroll)
  })
}

export const easeInOutCubic = (x: number) => {
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2
}

export const getScrollTarget = (
  container: HTMLElement,
  allMessages: MessageData[],
  prevLength: number,
  currentLength: number
) => {
  const { scrollHeight, clientHeight } = container
  const numNewMessages = currentLength - prevLength
  const isContentFitting = scrollHeight <= clientHeight
  let targetTop = scrollHeight
  let targetElement: HTMLElement | null = null

  if (isContentFitting) {
    return targetTop
  }

  if (numNewMessages >= 2) {
    const secondMessageIndex = prevLength + 1
    const secondNewMessageId = allMessages[secondMessageIndex]?.data.id
    targetElement = secondNewMessageId
      ? container.querySelector<HTMLElement>(
          `#message_${secondNewMessageId}__${secondMessageIndex}`
        )
      : null
  }

  if (targetElement) {
    targetTop = Math.max(0, targetElement.offsetTop - 90)
  }
  return targetTop
}
